import { IMaintenanceData } from '@/models';
import {
  IFetchMaintenancesParams,
  IMaintenanceService
} from './maintenance.types';
import { AxiosInstance } from 'axios';

export class MaintenanceService implements IMaintenanceService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/maintenances/';
  }

  fetchMaintenances(
    params: IFetchMaintenancesParams
  ): Promise<IMaintenanceData[]> {
    return this.axios
      .get<IMaintenanceData[]>(`${this.endpoint}`, {
        headers: {
          Authorization: null
        },
        params
      })
      .then(({ data }) => data);
  }

  fetchMaintenance(id: number): Promise<IMaintenanceData> {
    return this.axios
      .get<IMaintenanceData>(`${this.endpoint}${id}/`, {
        headers: {
          Authorization: null
        }
      })
      .then(({ data }) => data);
  }

  createMaintenance(data: IMaintenanceData): Promise<IMaintenanceData> {
    return this.axios
      .post<IMaintenanceData>(`${this.endpoint}`, data)
      .then(({ data }) => data);
  }

  updateMaintenance(data: IMaintenanceData): Promise<IMaintenanceData> {
    return this.axios
      .patch<IMaintenanceData>(`${this.endpoint}${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteMaintenance(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}${id}/`);
  }
}
